const publicPath = document.getElementById("publicPath")?.innerHTML;
/* global __webpack_public_path__:writable */ // eslint-disable-line @typescript-eslint/no-unused-vars
//@ts-ignore
__webpack_public_path__ = publicPath;
